import classNames from "classnames";
import { STATE_TX } from "../../../../../modules/Account/components/TransactionHistory/transactionHistoryConstants";
import { BinIcon } from "../../../../../components/icon/Icon";
import { MobileHistoryTransactionStatusInfoStyled } from "./styled/MobileHistoryTransactionStatusInfoStyled";

const stateToIcon = {
    processing: {
        iconName: 'IcClock',
        iconColor: 'var(--color-secondary-active)',
    },
    error: {
        iconName: 'IcXCircleRed',
    },
    rejected: {
        iconName: 'IcXCircleRed',
    },
    completed: {
        iconName: 'IcCheckMarkCircleGreen',
    },
};

function StatusIcon(props) {
    const {state} = props;

    return <BinIcon
        name={stateToIcon[state]?.iconName}
        style={{fill: stateToIcon[state]?.iconColor}}
    />
}

function MobileHistoryTransactionStatusInfo(props) {
    const {children, title, description, state} = props;

    return <MobileHistoryTransactionStatusInfoStyled className={classNames("mt-2rem", {
        'positive': state === STATE_TX.COMPLETED,
        'negative': [STATE_TX.ERROR, STATE_TX.REJECTED].includes(state),
    })}
    >
        <div className="d-flex">
            <div className="f16 me-2">
                <StatusIcon state={state}/>
            </div>
            <div>
                <h6 className="title mb-0">{title}</h6>
                <span className="description">{description}</span>
            </div>
        </div>
        {children}
    </MobileHistoryTransactionStatusInfoStyled>
}

export default MobileHistoryTransactionStatusInfo;
